import { createAction } from '@ngrx/store';
import { PromptOption } from 'src/app/pages/prompt-register/models/prompt-option.interface';
import { createEagerSelectActions } from '../../select/eager-select/eager-select-actions';

export const promptOptionActions = createEagerSelectActions<PromptOption>('[Prompt Options]');
export const resetPromptOptions = createAction('[Prompt Options] Reset');
